const initialState = {
  text: "",
};

export default function AppointmentPageTextReducer(state=initialState, action) {
  switch (action.type) {
    case 'REQUEST_FAIL' : {
      return { data: action.payload };
    }
    case 'RESPONSE_LOAD_OK' : {
      return Object.assign({}, state, {
        text: action.data,
      })
    }
    default: return state;
  }
}



// WEBPACK FOOTER //
// frontend/src/reducers/AppointmentPageTextReducer.js